import { Content } from "./Content";
import { Header } from "./Header";
import { Message } from "./Message";
import { Root } from "./Root";
import { BottomArea } from "./BottomArea";

export const Chat = {
    Root,
    Content,
    Header, 
    Message,
    BottomArea
}